import { ReactComponent as ClassNoData } from 'assets/icons/no-data-class-icon.svg';
import { MyCheckbox } from 'components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InternalDrawer from '../FormInformation/InternalDrawer';
import CostInfo from './CostInfo';
import PriceDiscount from './PriceDiscount';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import './Pricing.scss';

const Pricing = (props) => {
  const formik = props;
  const [active, setActive] = useState('costInfo');

  const resetPricing = () => {
    const updatedPrices = formik.values?.prices?.map((price) => {
      return {
        ...price,
        amount: '',
        quantity: '',
        variantInfo: price?.variantInfo?.map((variant) => {
          return {
            ...variant,
            quantity: '',
          };
        }
        ),
      };
    });
    formik.setFieldValue('prices', updatedPrices);
    formik.setFieldValue('discount', []);
    formik.setFieldValue('step2Active', 'costInfo');
  }
const hasCostInfoErrors =
  Array.isArray(formik.errors?.prices) &&
  formik.errors.prices.some((item, i) =>
    item && Object.keys(item).length > 0 && formik.touched?.prices?.[i]
  );

const hasDiscountErrors =
  Array.isArray(formik.errors?.discount) &&
  formik.errors.discount.some((item, i) =>
    item && Object.keys(item).length > 0 && formik.touched?.discount?.[i]
  );

  return (
    <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
          <div className='pricing__head d-flex justify-content-between'>
            <div className="info_title">
              <h2>Pricing Information</h2>
              <p>Please complete the details below</p>
            </div>
            <div className='pricing__free-box'>
              <MyCheckbox
                title="Non-Payment Form"
                checked={formik.values?.freeForm}
                handlechange={() => {
                  formik.setFieldValue(
                    'freeForm',
                    !formik.values?.freeForm
                  );
                }}
                titleStyles={{
                  fontSize: "12px"
                }}
              />
            </div>
          </div>
          <div className="class__tabs"
            style={{
              opacity: formik.values?.freeForm ? '0.5' : '1',
              pointerEvents: formik.values?.freeForm ? 'none' : 'all'
            }}
          >
            <p
              className={formik.values?.step2Active === 'costInfo' ? 'active' : 'inactive'}
              onClick={() => formik.setFieldValue("step2Active", 'costInfo')}
            >
           <span style={{marginRight:"5px"}}>   Cost Info</span>
              {hasCostInfoErrors && (
    <ErrorOutlineIcon style={{ color: "#dc3545", fontSize: 18 }} />
  )}
            </p>
            <p
              className={formik.values?.step2Active === 'priceDiscount' ? 'active' : 'inactive'}
              onClick={() => formik.setFieldValue("step2Active", 'priceDiscount')}
            >
             <span style={{marginRight:"5px"}}>Discount</span> 
              {hasDiscountErrors && (
    <ErrorOutlineIcon style={{ color: "#dc3545", fontSize: 18 }} />
  )}
            </p>
          </div>
          <div className="classTap_content"
            style={{
              opacity: formik.values?.freeForm ? '0.5' : '1',
              pointerEvents: formik.values?.freeForm ? 'none' : 'all'
            }}
          >
            {formik.values?.step2Active === 'costInfo' ? (
              <CostInfo formik={formik} />
            ) : (
              <PriceDiscount formik={formik} />
            )}
          </div>
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik} />
      </div>
    </div>
  );
};

export default Pricing;
